import $ from 'jquery'
import videojs from 'video.js'
import * as api from '../api/passport'
import apiService from '@/lib/api-service'

export default {
  changeMainMenu: ({ commit }, mainMenu) =>
    commit('CHANGE_MAIN_MENU', mainMenu),
  increaseZIndex: ({ commit }) => commit('INCREASE_MAX_ZINDEX'),
  showAlert: ({ commit }, prop) => {
    // {msg, title, cb}
    let kv = prop

    if (typeof kv === 'string') {
      kv = {
        msg: kv
      }
    }

    commit('SHOW_ALERT', kv)
  },
  hideAlert: ({ commit }) => commit('HIDE_ALERT'),
  showConfirm: ({ commit }, prop) => {
    // {msg, title, ok, cancel}
    commit('SHOW_CONFIRM', prop)
  },
  hideConfirm: ({ commit }) => commit('HIDE_CONFIRM'),
  showLoading: ({ commit }, msg, html) => commit('SHOW_LOADING', msg),
  hideLoading: ({ commit }) => commit('HIDE_LOADING'),
  toast: ({ commit }, param) => {
    let kv = param

    if (typeof kv === 'string') {
      kv = {
        msg: kv
      }
    }
    commit('SHOW_TOAST', kv)
  },
  hideToast: ({ commit }) => commit('HIDE_TOAST'),
  showSelectImgWin: ({ commit }, config) =>
    commit('SHOW_SELECT_IMG_WIN', config),
  hideSelectImgWin: ({ commit }) => commit('HIDE_SELECT_IMG_WIN'),
  showSelectVideoWin: ({ commit }, config) =>
    commit('SHOW_SELECT_VIDEO_WIN', config),
  hideSelectVideoWin: ({ commit }) => commit('HIDE_SELECT_VIDEO_WIN'),
  showSelectAudioWin: ({ commit }, config) =>
    commit('SHOW_SELECT_AUDIO_WIN', config),
  hideSelectAudioWin: ({ commit }) => commit('HIDE_SELECT_AUDIO_WIN'),
  showSelectArticleWin: ({ commit }, config) =>
    commit('SHOW_SELECT_ARTICLE_WIN', config),
  hideSelectArticleWin: ({ commit }) => commit('HIDE_SELECT_ARTICLE_WIN'),
  showSelectModel3dWin: ({ commit }, config) =>
    commit('SHOW_SELECT_MODEL3D_WIN', config),
  hideSelectModel3dWin: ({ commit }) => commit('HIDE_SELECT_MODEL3D_WIN'),
  showSelectUnity3dWin: ({ commit }, config) =>
    commit('SHOW_SELECT_UNITY3D_WIN', config),
  hideSelectUnity3dWin: ({ commit }) => commit('HIDE_SELECT_UNITY3D_WIN'),
  addGroup: ({ commit }, group) => commit('ADD_GROUP', group),
  initGroups: ({ commit }) => {
    return apiService.get_material_group_listAll({}).then(result => {
      if (result.code === 200 && result.data) {
        commit('REFRESH_GROUPS', result.data)
      }
    })
  },
  // src, poster, title
  showPlayer: ({ commit }, prop) => commit('SHOW_PLAYER', prop),
  hidePlayer: ({ commit }) => commit('HIDE_PLAYER'),
  changeProjectStatus: ({ commit }, param) => {
    // pid, status
    if (!param) {
      return
    }

    return apiService.update_project_changestatus(param)
  },
  initLoginUser: ({ commit }) => {
    return apiService.get_user_getLoginUser({}).then(data => {
      if (data && data.code === 200) {
        commit('INIT_LOGIN_USER', data.data)
      }
    })
  },
  refreshLoginUser: ({ commit }, user) => {
    commit('INIT_LOGIN_USER', user)
  },
  audit: ({ commit }, prop) => {
    //  pid, type
    commit('SHOW_LOADING', '审核中，请稍后...')
    return apiService[`update_project_audit_${prop.type}`](prop)
      .then(ret => {
        if (ret && ret.message) {
          commit('SHOW_TOAST', { msg: ret.message })
        }
        return ret
      })
      .finally(() => {
        commit('HIDE_LOADING')
      })
  },
  itemAudit: ({ commit }, prop) => {
    // iid, pid, type, info
    commit('SHOW_LOADING', '审核中，请稍后...')

    return apiService[`update_project_audit_item_${prop.type}`](prop)
      .then(ret => {
        if (ret && ret.message) {
          commit('SHOW_TOAST', { msg: ret.message })
        }

        return ret
      })
      .finally(() => {
        commit('HIDE_LOADING')
      })
  },
  saveVideoTime: ({ commit }, param) => {
    // type, id, url

    let totalSecond
    const _player = videojs($('<video></video>')[0], {}, function () {
      // Player (this) is initialized and ready.
    })

    _player.on('durationchange', function () {
      totalSecond = _player.duration()

      if (totalSecond) {
        apiService.update_material_saveTime({
          type: param.type,
          id: param.id,
          totalTime: totalSecond
        })
      }
    })

    _player.src(param.url)
  },
  getPermission ({ commit }, params) {
    return api.getPermission(params).then(function (result) {
      if (result.code === 200) {
        commit('GET_PERMISSION', result.data)
      }
    })
  }
}
